import { render, staticRenderFns } from "./ModalRemuneracaoSuporteHospital.vue?vue&type=template&id=5334cd09&scoped=true"
import script from "./ModalRemuneracaoSuporteHospital.vue?vue&type=script&lang=ts"
export * from "./ModalRemuneracaoSuporteHospital.vue?vue&type=script&lang=ts"
import style0 from "./ModalRemuneracaoSuporteHospital.vue?vue&type=style&index=0&id=5334cd09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334cd09",
  null
  
)

export default component.exports